import React, { useCallback, useEffect, useState } from "react";

import TextHorizontalCard from "../cards/textHorizontalCard";
import { Paginator } from "../shared/paginator";

const TextContentFullwidthList = ({ contentList }) => {
  const [visibleCnt, setVisibleCnt] = useState(3);
  const [pagination, setPagination] = useState(true);

  useEffect(() => {
    if (visibleCnt > 3) setPagination(false);
  }, [visibleCnt]);

  const handlePagination = useCallback(() => {
    setVisibleCnt((prevState) => prevState + 2);
  }, []);

  const { sectionTitle, list } = contentList;

  return (
    <>
      {list && list.length > 0 && (
        <section className="w-full flex justify-center bg-yellow-lighter planet:bg-gray-dark">
          <div className="text-card-list relative w-11/12 md:w-9/12 mx-auto pt-20 pb-[148px] md:pb-40 bg-inherit">
            {sectionTitle && (
              <h1
                className="pb-14 !font-light planet:!font-light"
                dangerouslySetInnerHTML={{ __html: sectionTitle }}
              />
            )}
            <Paginator
              pagination={pagination}
              paginationCallback={handlePagination}
            >
              <div
                className={`relative flex flex-col gap-5 md:gap-10
        `}
              >
                {list &&
                  list.length &&
                  list
                    ?.slice(0, visibleCnt)
                    ?.map((item, index) => (
                      <TextHorizontalCard
                        key={index}
                        title={item?.title}
                        imgSrc={item?.imgSrc}
                        desc={item?.desc}
                        url={item?.ctaLink ?? false}
                        linkTitle={item?.ctaTitle ?? "Read more"}
                        type="author"
                      />
                    ))}
              </div>
            </Paginator>
          </div>
        </section>
      )}
    </>
  );
};

export default TextContentFullwidthList;
